module.exports = __webpack_public_path__ + "static/media/baja-3.9797192d.jpg";